import { render, staticRenderFns } from "./SmartClassifierDataSetList.vue?vue&type=template&id=a1c2d626&scoped=true&"
import script from "./SmartClassifierDataSetList.vue?vue&type=script&lang=js&"
export * from "./SmartClassifierDataSetList.vue?vue&type=script&lang=js&"
import style0 from "./SmartClassifierDataSetList.vue?vue&type=style&index=0&id=a1c2d626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c2d626",
  null
  
)

export default component.exports